module.exports = __webpack_public_path__ + "img/2.d2294344.jpg";